export const BASE = process.env.REACT_APP_BASE_URL || 'https://app.farmapolis.es/'
export const API = 'api/v1/'
export const BASE_URL = process.env.REACT_APP_API_PATH || `${BASE}${API}`
export const FARMACLOUD_URL = process.env.REACT_APP_URL_FARMACLOUD_BACKEND || 'https://accounts.farmacloud.io/sso/farmapolis?login='
